import { GraphemeMnemonicsMeaningScreen } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._screens.meaning";

/**
 * The meaning screen, for the Reference page's first section.
 *
 * Takes no grapheme: like the panel tab it renders in, it reads the character from
 * `MorphemePanelsContext`, so it only works inside that provider's subtree.
 */
export function GraphemeMnemonicsMeaningReferenceSection() {
  return <GraphemeMnemonicsMeaningScreen />;
}
